export default __webpack_public_path__ + "static/media/aiguille.7d18bafa.png";